import { call, put } from 'redux-saga/effects';
import { SagaIterator } from 'redux-saga';
import { PayloadAction } from '@reduxjs/toolkit';
import apiRequests from 'config/services';
import { sagaGetAssemblyListingAction } from 'saga/actions/assembler';
import { assemblerConstants } from 'saga/actions/assembler';
import { takeLatest } from 'redux-saga/effects';
import { CalculationProcessStep } from 'store/types/assembler';

export function* createAssemblySaga(
  action: PayloadAction<{ name: string, calculationProcessChain?: CalculationProcessStep[] }>
): SagaIterator {
  try {
    // Destructure from the action payload
    const { name, calculationProcessChain } = action.payload;

    // Call your API function with both arguments
    const data: any = yield call(apiRequests.createNewAssembly, name, calculationProcessChain);

    // Save to global state
    //yield put(setassemblyModel(data));
    yield put(sagaGetAssemblyListingAction())      // Refresh the list of assemblies

  } catch (e) {
  }
}

// Listener saga
export function* createAssemblyHook() {
  // on SAGA_GET_SEARCH_RESULTS action, run getSearchResultsSaga
  yield takeLatest(assemblerConstants.SAGA_CREATE_ASSEMBLY, createAssemblySaga)
}
